module.exports = __webpack_public_path__ + "img/kovalenko.e4f2c4d3.jpg";